import { type RouteComponentProps } from "react-router";

import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { isValidId } from "commonComponents/utilities/DropDown/DropDown";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import SelectionOptionModal from "entity/selectionOption/modal/SelectionOptionModal";
import { type ISelectionOptionLocationState } from "entity/selectionOptions/SelectionOption/SelectionOption.types";

export const RouteSelectionOption = (props: {
    modalConfig: { beforeClose: () => void; parentRoute: string };
}) => (
    <RouteRelative
        path={routes.selectionOptions.modalDetails}
        render={(
            routeProps: RouteComponentProps<{
                selectionOptionId: string;
                jobId: string;
            }>,
        ) => {
            const stringSelectionOptionId = routeProps.match.params.selectionOptionId;
            const selectionOptionId = stringSelectionOptionId
                ? parseInt(stringSelectionOptionId)
                : undefined;
            const modalJobId = parseInt(routeProps.match.params.jobId);
            const openComments =
                (routeProps.location.state as ISelectionOptionLocationState | null)
                    ?.openComments === true;

            // bail out in case reached with no jobid
            if (!isValidId(modalJobId)) {
                return null;
            }

            return (
                <BTSuspense>
                    <SelectionOptionModal
                        isVisible={true}
                        selectionOptionId={selectionOptionId}
                        jobId={modalJobId}
                        onClose={props.modalConfig.beforeClose}
                        openComments={openComments}
                    />
                </BTSuspense>
            );
        }}
    />
);
